import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box, Card, CardContent, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, CircularProgress,
  AppBar, Toolbar, IconButton, Grid
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { UrlApiEnvasado } from '../../../../../services/apirest';
import moment from 'moment';

function VerFactura() {
  const location = useLocation();
  const navigate = useNavigate();
  const { tipo, suc, nro, origen } = location.state || {};
  const [factura, setFactura] = useState(null);
  const [loading, setLoading] = useState(true);

      const [origenTabla, setOrigenTabla] = useState("");
      useEffect(() => {
        if (origen === "bk1_aws_hipergas") {
          setOrigenTabla("api/estadistica");
        } else if (origen === "bk1_aws_aogas") {
          setOrigenTabla("db2/api/estadisticaaogas");
        }
      }, [origen]);
  useEffect(() => {
    const fetchFactura = async () => {
      if (!tipo || !suc || !nro) return;

      try {
        const response = await fetch(`${UrlApiEnvasado}${origenTabla}/deudores/especifico/${tipo}/${suc}/${nro}`);
        const data = await response.json();
        setFactura(data[0]);
      } catch (error) {
        console.error('Error fetching factura:', error);
      } finally {
        setLoading(false);
      }
    };
    if (origenTabla !== "") {
      fetchFactura();
    }
  }, [tipo, suc, nro,origenTabla]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f5f7fa"
        }}
      >
        <CircularProgress sx={{ color: "#1F618D", size: 32 }} />
      </Box>
    );
  }

  if (!factura) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: "#f5f7fa" }}>
        <Typography variant="h6" sx={{ color: "#1F618D", fontWeight: 500 }}>
          No se encontró la factura.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: "#f5f7fa", minHeight: "100vh" }}>
      <AppBar position="static" sx={{ 
        backgroundColor: "#1F618D",
        boxShadow: "0 2px 8px rgba(31, 97, 141, 0.2)"
      }}>
        <Toolbar sx={{ minHeight: 56 }}>
          <IconButton 
            edge="start" 
            color="inherit" 
            onClick={() => navigate(-1)}
            sx={{ '&:hover': { backgroundColor: 'rgba(255,255,255,0.15)' } }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ 
            flexGrow: 1, 
            fontWeight: 600,
            letterSpacing: 0.5,
            fontSize: '1.0rem',
            textAlign:"center"
          }}>
            Detalle de Factura
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Contenido principal */}
      <Box sx={{ p: 0.5 }}>
        {/* Información General */}
        <Card sx={{
          backgroundColor: "#ffffff",
          boxShadow: "0 2px 10px rgba(31, 97, 141, 0.1)",
          borderRadius: "10px",
          borderLeft: "4px solid #1F618D",
          mb: 1
        }}>
          <CardContent sx={{ p: 1 }}>
            <Typography variant="h6" sx={{
              color: "#1F618D",
              fontWeight: 600,
              fontSize: "1.0rem",
              mb: 0.5,
              textAlign: "center",
              textTransform: 'uppercase'
            }}>
              Información General
            </Typography>

            <Grid container spacing={2}>
              {[
                { label: 'Tipo Comprobante', value: factura.descripcion },
                { label: 'Sucursal', value: factura.name_sucursal },
                // { label: 'Pto. Venta', value: factura.ccd_suc },
                // { label: 'Número', value: factura.ccd_nro },
                {
                  // contenedor especial con dos ítems chicos
                  custom: true,
                  children: [
                    { label: 'Pto. Venta', value: factura.ccd_suc },
                    { label: 'Número', value: factura.ccd_nro },
                  ],
                },
                { label: 'Fecha', value: moment(factura.ccd_fecha_mov, "DD-MM-YYYY HH:mm").format("DD/MM/YYYY HH:mm") },
                { label: 'Facturado a', value: factura.name_cliente },
                { label: 'Cliente', value: factura.name_cliente_adi },
                { label: 'Vendedor', value: factura.name_vendedor },
                { label: 'Total', value: `$${parseFloat(factura.ccd_total).toFixed(2)}` },
                // { label: 'CAE', value: factura.ucd_cae || 'N/A' },
                {
                  // contenedor especial con dos ítems chicos
                  custom: true,
                  children: [
                     { label: 'CAE', value: factura.ucd_cae || 'N/A' },
                     { label: 'Vto CAE', value: factura.ucd_fecha_cae ? moment(factura.ucd_fecha_cae).format("DD/MM/YYYY") : 'N/A' },
                  ],
                },
                { label: 'Patente', value: factura.patente || 'N/A' },
                { label: 'Rendición', value: factura.ccd_nro_suc_rend ? `${factura.ccd_nro_suc_rend}/${factura.ccd_nro_nro_rend}` : 'N/A' },
                // { label: 'Vencimiento', value: factura.ccd_fecha_venc ? moment(factura.ccd_fecha_venc).format("DD/MM/YYYY") : 'N/A' },
                // { label: 'Cond. Venta', value: factura.desc_condventa || 'N/A' },
                {
                  // contenedor especial con dos ítems chicos
                  custom: true,
                  children: [
                     { label: 'Cond. Venta', value: factura.desc_condventa || 'N/A' },
                     { label: 'Vencimiento', value: factura.ccd_fecha_venc ? moment(factura.ccd_fecha_venc).format("DD/MM/YYYY") : 'N/A' },
                  ],
                },
                // { label: 'Fecha CAE', value: factura.ucd_fecha_cae ? moment(factura.ucd_fecha_cae).format("DD/MM/YYYY") : 'N/A' },
              ].map((item, index) => (
                item.custom ? (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Grid container spacing={1}>
          {item.children.map((child, i) => (
            <Grid item xs={6} key={i}>
              <Box
                sx={{
                  backgroundColor: "#ffffff",
                  borderRadius: "6px",
                  p: 0.3,
                  height: "90%",
                  border: "1px solid #e0e7ed",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "#1F618D",
                    fontWeight: 500,
                    fontSize: "0.80rem",
                    lineHeight: 1.3,
                    mb: 0.3,
                  }}
                >
                  {child.label}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#2C3E50",
                    fontSize: "0.9rem",
                    lineHeight: 1.3,
                    wordBreak: "break-word",
                  }}
                >
                  {child.value}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    ) : (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Box
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "6px",
            p: 0.3,
            height: "90%",
            border: "1px solid #e0e7ed",
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              color: "#1F618D",
              fontWeight: 500,
              fontSize: "0.80rem",
              lineHeight: 1.3,
              mb: 0.3,
            }}
          >
            {item.label}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#2C3E50",
              fontSize: "0.9rem",
              lineHeight: 1.3,
              wordBreak: "break-word",
            }}
          >
            {item.value}
          </Typography>
        </Box>
      </Grid>)
              ))}
            </Grid>
          </CardContent>
        </Card>

        {/* Detalles de los Renglones */}
        <Card sx={{
          backgroundColor: "#ffffff",
          boxShadow: "0 2px 10px rgba(31, 97, 141, 0.1)",
          borderRadius: "10px",
          borderLeft: "4px solid #1F618D"
        }}>
          <CardContent sx={{ p: 1 }}>
            <Typography variant="h6" sx={{
              color: "#1F618D",
              fontWeight: 600,
              fontSize: "1.0rem",
              mb: 0.5,
              textAlign: "center",
              textTransform: 'uppercase'
            }}>
              Detalle
            </Typography>

            <TableContainer component={Paper} sx={{
              borderRadius: "8px",
              border: "1px solid #e0e7ed",
              maxHeight: "400px",
              overflow: "auto",
              "&::-webkit-scrollbar": { width: "6px", height: "4px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#1F618D",
                borderRadius: "3px",
              },
            }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    {["Cantidad", "Producto", "P. Unitario", "Total"].map((header, index) => (
                      <TableCell key={index} 
                      sx={{
                        fontWeight: 600,
                        color: "#1F618D",
                        backgroundColor: "#f0f7fa",
                        borderBottom: "2px solid #1F618D",
                        py: 1,
                        fontSize: '0.85rem',
                        borderRight: "2px solid #e0e0e0",
                      }}
                      align='center'
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {factura.detalles_renglones.split(' | ').map((renglon, index) => {
                    const partes = renglon.split(' - ');
                    const renglonObj = {};
                    partes.forEach((parte) => {
                      const [key, value] = parte.split(': ');
                      renglonObj[key.trim()] = value.trim();
                    });
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:nth-of-type(odd)": { backgroundColor: "#ffffff" },
                          "&:nth-of-type(even)": { backgroundColor: "#f8fafc" },
                          "&:hover": { backgroundColor: "#f0f7ff" }
                        }}
                      >
                        <TableCell sx={{ color: "#2C3E50", fontSize: "0.85rem", py: 0.5, borderRight: "2px solid #e0e0e0" }} align='right'>
                          {renglonObj.Cantidad}
                        </TableCell>
                        <TableCell sx={{ color: "#2C3E50", fontSize: "0.85rem", py: 0.5, borderRight: "2px solid #e0e0e0" }}>
                          {renglonObj.Producto}
                        </TableCell>
                        <TableCell sx={{ color: "#2C3E50", fontSize: "0.85rem", py: 0.5, borderRight: "2px solid #e0e0e0" }} align='right'>
                          ${Number(renglonObj.Precio).toFixed(2)}
                        </TableCell>
                        <TableCell sx={{ color: "#2C3E50", fontSize: "0.85rem", py: 0.5, borderRight: "2px solid #e0e0e0" }} align='right'>
                          ${Number(renglonObj.Total).toFixed(2)}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export default VerFactura;